import AutomatonSectionIconLayer from '@components/map/layers/automatonSections/AutomatonSectionIconLayer';
import AutomatonSectionLineLayer from '@components/map/layers/automatonSections/AutomatonSectionLineLayer';
import EventLayer from '@components/map/layers/event/EventLayer';
import GroundStationLayer from '@components/map/layers/groundStation/GroundStationLayer';
import LadCameraCoverageLayer from '@components/map/layers/ladCameras/LadCameraCoverageLayer';
import NeutralSectorsLayer from '@components/map/layers/neutralSectors/NeutralSectorsLayer';
import PerimeterCameraLabelLayer from '@components/map/layers/perimeterCameras/PerimeterCameraLabelLayer';
import PerimeterCameraSectorLayer from '@components/map/layers/perimeterCameras/PerimeterCameraSectorLayer';
import PerimeterSensorLayer from '@components/map/layers/perimeterSensors/PerimeterSensorLayer';
import PoiLayer from '@components/map/layers/poi/PoiLayer';
import PolygonLayer from '@components/map/layers/polygons/PolygonLayer';
import RadarCoverageLayer from '@components/map/layers/radarCoverage/RadarCoverageLayer';
import SensorLayer from '@components/map/layers/sensors/SensorLayer';
import StrobeLayer from '@components/map/layers/strobes/StrobeLayer';
import TargetLayer from '@components/map/layers/targets/TargetLayer';
import PermanentTooltips from '@components/map/tooltips/PermanentTooltips';

export function CommonMapLayers() {
  return (
    <>
      <RadarCoverageLayer />
      <PerimeterCameraSectorLayer />
      <NeutralSectorsLayer />
      <AutomatonSectionLineLayer />
      <PerimeterCameraLabelLayer />
      <LadCameraCoverageLayer />
      <StrobeLayer />
      <PolygonLayer />
      <GroundStationLayer />
      <PerimeterSensorLayer />
      <SensorLayer />
      <AutomatonSectionIconLayer />
      <PoiLayer />
      <EventLayer />
      <TargetLayer />
      <PermanentTooltips />
    </>
  );
}
